import axios from "./index";

let base = "";

class SettingApi {
  static UpdateSitesStock = () => {
    return axios.post(`${base}/settings/update-sites-stock`, []);
  };

  static UpdateSystemStock() {
    return axios.post(`${base}/settings/update-system-stock`);
  }

  static ImportProducts() {
    return axios.post(`${base}/settings/import-products`);
  }

  static UpdateSystemPrice = () => {
    return axios.post(`${base}/settings/update-system-price`);
  };
  
}

export default SettingApi;
